import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AccountRoutingModule } from './account-routing.module';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatCardModule } from '@angular/material/card';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AuthenticationComponent } from './components/authentication/authentication.component';
import { AccountPageComponent } from './components/page/account-page.component';
import { MatListModule } from '@angular/material/list';
import { ProfileComponent } from './components/profile/profile.component';
import { ProfileLanguageComponent } from './components/language/language.component';
import { MatMenuModule } from '@angular/material/menu';
import { MatIconModule } from '@angular/material/icon';
import { ProfileEditorModule } from '../profile-editor/profile-editor.module';
import { Angulartics2Module } from 'angulartics2';
import { InventorySettingsComponent } from './components/inventory/inventory.component';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { LanguageModule } from '../shared/language/language.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    MatFormFieldModule,
    MatCardModule,
    MatInputModule,
    MatButtonModule,
    AccountRoutingModule,
    ReactiveFormsModule,
    MatListModule,
    MatMenuModule,
    MatIconModule,
    ProfileEditorModule,
    Angulartics2Module,
    MatSlideToggleModule,
    LanguageModule
  ],
  declarations: [
    AuthenticationComponent, 
    AccountPageComponent, 
    ProfileComponent, 
    InventorySettingsComponent,
    ProfileLanguageComponent
  ],
})
export class AccountModule { }
